import 'slick-carousel';

// Variable Declaration
const $carousel = $('#imp-carousel');
const $control = $('.imp-carousel-control');

// Initialization carousel
$carousel.slick({
  infinite: false,
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  arrows: false,
  prevArrow: '<button class="arrow arrow-prev1"></button>',
  nextArrow: '<button class="arrow arrow-next"></button>',
  responsive: [{
    breakpoint: 1024,
    settings: {
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: false,
    }
  }]
});

